// Generated by purs version 0.14.3
"use strict";
var AnyAll_Relevance = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/src/AnyAll/Relevance.purs");
var AnyAll_Types = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/src/AnyAll/Types.purs");
var Control_Monad_Except = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Except.purs");
var Data_Either = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/either/v5.0.0/src/Data/Either.purs");
var Data_Foldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foldable-traversable/v5.0.1/src/Data/Foldable.purs");
var Data_List_Types = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/lists/v6.0.1/src/Data/List/Types.purs");
var Data_Map_Internal = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/ordered-collections/v2.0.1/src/Data/Map/Internal.purs");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var Data_Ord = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Ord.purs");
var Data_Show = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Show.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var Effect_Console = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/console/v5.0.0/src/Effect/Console.purs");
var Foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign.purs");
var Foreign_Generic_Class = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-generic/v11.0.0/src/Foreign/Generic/Class.purs");
var Partial_Unsafe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/partial/v3.0.0/src/Partial/Unsafe.purs");
var RuleLib_PDPADBNO = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/src/RuleLib/PDPADBNO.purs");
var soft = AnyAll_Types.Soft.value;
var pdpa_dbno_s1p1_nl = RuleLib_PDPADBNO.schedule1_part1_nl;
var pdpa_dbno_s1p1 = RuleLib_PDPADBNO.schedule1_part1;
var paintQ = function (m) {
    return function (nl) {
        return function (i) {
            return AnyAll_Relevance.relevant(AnyAll_Types.Hard.value)(AnyAll_Types.DPNormal.value)(m)(Data_Maybe.Nothing.value)(nl)(i);
        };
    };
};
var marking1 = AnyAll_Types.markup(Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray)([ Data_Tuple.Tuple.create("walk")(new Data_Either.Right(new Data_Maybe.Just(true))), Data_Tuple.Tuple.create("run")(new Data_Either.Left(new Data_Maybe.Just(true))), Data_Tuple.Tuple.create("eat")(new Data_Either.Left(new Data_Maybe.Just(true))), Data_Tuple.Tuple.create("drink")(new Data_Either.Right(new Data_Maybe.Just(false))) ]));
var marking1_encoded = Foreign_Generic_Class.encode(AnyAll_Types.encodeMarking)(marking1);
var main = Effect_Console.log("AnyAll main");
var howDoWeEven = function (arg1) {
    return function (arg2) {
        return "arg 1 = " + (arg1 + ("; arg 2 = " + Data_Show.show(Data_Show.showInt)(arg2)));
    };
};
var hard = AnyAll_Types.Hard.value;
var fromNode2 = function (x) {
    return "hello node, you said " + x;
};
var fromNode1 = "hello node";
var exampleAny = new AnyAll_Types.Any(new AnyAll_Types.Pre("all of"), [ new AnyAll_Types.Leaf("walk"), new AnyAll_Types.Leaf("run") ]);
var example1_nl = Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray)([ Data_Tuple.Tuple.create("en")(Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray)([ new Data_Tuple.Tuple("walk", "walk slowly"), new Data_Tuple.Tuple("run", "run fast"), new Data_Tuple.Tuple("eat", "eat food"), new Data_Tuple.Tuple("drink", "drink beverages") ])) ]);
var nlLibrary = Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray)([ new Data_Tuple.Tuple("example1", example1_nl), new Data_Tuple.Tuple("pdpa_dbno_s1p1", pdpa_dbno_s1p1_nl) ]);
var getNLByName = function (itemname) {
    var v = Data_Map_Internal.lookup(Data_Ord.ordString)(itemname)(nlLibrary);
    if (v instanceof Data_Maybe.Nothing) {
        return Partial_Unsafe.unsafeCrashWith("anyall: unable to find nldict named " + itemname);
    };
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    throw new Error("Failed pattern match at AnyAll (line 159, column 3 - line 161, column 24): " + [ v.constructor.name ]);
};
var example1 = new AnyAll_Types.All(new AnyAll_Types.Pre("all of"), [ new AnyAll_Types.Leaf("walk"), new AnyAll_Types.Leaf("run"), new AnyAll_Types.Any(new AnyAll_Types.Pre("either"), [ new AnyAll_Types.Leaf("eat"), new AnyAll_Types.Leaf("drink") ]) ]);
var example1_encoded = Foreign_Generic_Class.encode(AnyAll_Types.encodeItem(Foreign_Generic_Class.stringEncode))(example1);
var itemLibrary = Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray)([ new Data_Tuple.Tuple("example1", example1), new Data_Tuple.Tuple("pdpa_dbno_s1p1", pdpa_dbno_s1p1) ]);
var getItemByName = function (itemname) {
    var v = Data_Map_Internal.lookup(Data_Ord.ordString)(itemname)(itemLibrary);
    if (v instanceof Data_Maybe.Nothing) {
        return Partial_Unsafe.unsafeCrashWith("anyall: unable to find rule item named " + itemname);
    };
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    throw new Error("Failed pattern match at AnyAll (line 153, column 3 - line 155, column 24): " + [ v.constructor.name ]);
};
var output1q = paintQ(marking1)(example1_nl)(example1);
var output1 = AnyAll_Types.qoutjs(output1q);
var fromNode3 = output1;
var emptyMarking = AnyAll_Types.markup(Data_Map_Internal.empty);
var pdpaQ = paintQ(emptyMarking)(pdpa_dbno_s1p1_nl)(pdpa_dbno_s1p1);
var decodeMarking = function (marking) {
    var eitherm = Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(AnyAll_Types.decodeMarking)(marking));
    return Data_Either.either(function (e) {
        return Partial_Unsafe.unsafeCrashWith("error in decodeMarking" + Data_Show.show(Data_List_Types.showNonEmptyList(Foreign.showForeignError))(e));
    })(function (m) {
        return m;
    })(eitherm);
};
var marking1_decoded = decodeMarking(marking1_encoded);
var marking1_recoded = function (dictEncode) {
    return function (x) {
        return decodeMarking(Foreign_Generic_Class.encode(dictEncode)(x));
    };
};
var paint = function (h) {
    return function (fm) {
        return function (nl) {
            return function (item) {
                return AnyAll_Types.qoutjs(AnyAll_Relevance.relevant(h)(AnyAll_Types.DPNormal.value)(decodeMarking(fm))(Data_Maybe.Nothing.value)(nl)(item));
            };
        };
    };
};
var decodeItemString = AnyAll_Types.decodeIt;
var anyallform1 = output1;
module.exports = {
    fromNode1: fromNode1,
    fromNode2: fromNode2,
    fromNode3: fromNode3,
    emptyMarking: emptyMarking,
    example1_nl: example1_nl,
    example1: example1,
    exampleAny: exampleAny,
    example1_encoded: example1_encoded,
    marking1: marking1,
    marking1_encoded: marking1_encoded,
    marking1_decoded: marking1_decoded,
    marking1_recoded: marking1_recoded,
    anyallform1: anyallform1,
    decodeMarking: decodeMarking,
    pdpa_dbno_s1p1: pdpa_dbno_s1p1,
    pdpa_dbno_s1p1_nl: pdpa_dbno_s1p1_nl,
    pdpaQ: pdpaQ,
    paint: paint,
    paintQ: paintQ,
    hard: hard,
    soft: soft,
    howDoWeEven: howDoWeEven,
    getItemByName: getItemByName,
    getNLByName: getNLByName,
    decodeItemString: decodeItemString
};

